
const ProcessMonitoringSection = () => {
  return (
    <section className="py-16 bg-slate-900">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">Advanced <span className="text-[#8932c8]">Process Monitoring</span></h2>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Our platform provides detailed visibility into processes across your environment, 
              identifying suspicious activities and containing threats in real-time.
            </p>
          </div>
          <div className="rounded-xl overflow-hidden shadow-2xl">
            <img 
              src="/lovable-uploads/50e33ee3-048d-4497-94c8-401e597d369c.png" 
              alt="Advanced Process Monitoring capability of Spharaka Autonomous Cyber Defence Platform with AuraXP" 
              className="w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessMonitoringSection;
